(() => {
  if (window.__pawtySearchTriggerReady) return;
  window.__pawtySearchTriggerReady = true;

  document.addEventListener('click', (event) => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-pawty-search-trigger]') : null;
    if (!trigger) return;

    const searchModal = document.getElementById('search-modal');
    const dialog = searchModal?.querySelector('dialog');
    if (dialog?.open) return;

    event.preventDefault();
    if (typeof searchModal?.showDialog === 'function') {
      searchModal.showDialog();
    } else if (dialog && typeof dialog.showModal === 'function') {
      dialog.showModal();
    }
  });
})();
